module.exports = __webpack_public_path__ + "img/portis.36760a8c.svg";